import { heroHighlights } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20amber%20and%20terracotta%20gradient%20backdrop%20with%20soft%20glowing%20light%20particles%20and%20subtle%20film%20grain%20texture%2C%20dark%20vignette%20edges%20to%20keep%20overlaid%20text%20readable%2C%20elegant%20minimalist%20artistic%20composition%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=cupfox-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-5xl mx-auto text-center">
          <span className="animate-rise inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs md:text-sm text-background-50">
            <i className="ri-anchor-line"></i>
            入口 · 地址 · 发布页 · 防走失
          </span>

          <h1 className="animate-rise-delay-1 mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-background-50">
            茶杯狐影视
            <span className="block mt-3 text-xl md:text-3xl lg:text-4xl font-semibold text-primary-200">
              最新地址与官网入口导航说明
            </span>
          </h1>

          <p className="animate-rise-delay-2 mx-auto mt-6 max-w-3xl text-sm md:text-base leading-relaxed text-background-50/85">
            本页集中说明「茶杯狐影视」的平台入口与最新地址，涵盖官网入口、官方网址、发布页与永久入口等关联内容。
            无论你是第一次来到这里，还是想为日后访问留一手，都可以从下方快速了解该从哪里开始、如何长期防走失。
          </p>

          <div className="animate-rise-delay-2 mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#entrances"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              了解入口类型
            </a>
            <a
              href="#howto"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
            >
              <i className="ri-guide-line"></i>
              查看查找方法
            </a>
          </div>
        </div>

        <div className="max-w-5xl mx-auto mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {heroHighlights.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-50/20 bg-background-50/10 backdrop-blur-sm p-4 md:p-5"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50/15 text-primary-200">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-3 font-heading text-base font-semibold text-background-50">{item.title}</h3>
              <p className="mt-1 text-xs md:text-sm leading-relaxed text-background-50/75">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}